import { useEffect } from "react";
import { useSelector } from "react-redux";

export const WindowAutoClose = ({ timer }) => {
    return (
        <div className="auto-close-container">
            Window will auto close in {timer} second
        </div>
    );
};
